export default __webpack_public_path__ + "static/media/sn11.c0dc3861.jpg";